import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';

import { ILoadingOptions } from '@shared/models';
import { LoadingService } from '@shared/services';

@Component({
  selector: 'lib-loading',
  styleUrls: ['loading.component.scss'],
  templateUrl: 'loading.component.html',
  imports: [],
})
export class LoadingComponent implements AfterViewInit, OnDestroy {
  private readonly loadingScreenService = inject(LoadingService);
  private readonly elmRef = inject(ElementRef);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  public loadingSubscription: Subscription | undefined;
  public loadingOptions: ILoadingOptions | undefined;

  public ngAfterViewInit(): void {
    this.elmRef.nativeElement.style.display = 'none';
    this.loadingSubscription = this.loadingScreenService.loading$.pipe().subscribe((loadingOptions: ILoadingOptions) => {
      this.loadingOptions = loadingOptions;
      this.elmRef.nativeElement.style.display = loadingOptions.loading ? 'block' : 'none';
      this.changeDetectorRef.detectChanges();
    });
  }

  public ngOnDestroy() {
    this.loadingSubscription?.unsubscribe();
  }
}
